import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { BASE_URL } from '../config/api'; // Make sure to configure your API URL here

const EditPartyMaster = () => {
    const [party, setParty] = useState({
        name: '',
        number: '',
        address: '',
        city: '',
        pincode: '',
        state: '',
        type_karigar: '',
        dob: '',
        aod: '',
        mail_id: '',
        password: ''
    });
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();
    const { id } = useParams(); // Get the party ID from the URL params

    // Fetch party data to populate the form fields
    useEffect(() => {
        const fetchParty = async () => {
            try {
                const response = await fetch(`${BASE_URL}partymaster/${id}`);
                const data = await response.json();
                if (data.status === 1) {
                    setParty(data.data);
                } else {
                    setError(data.message);
                }
                setIsLoading(false);
            } catch (error) {
                setError('There was an error fetching the party data.');
                setIsLoading(false);
            }
        };

        fetchParty();
    }, [id]);

    // Handle form field changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setParty((prevParty) => ({
            ...prevParty,
            [name]: value
        }));
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await fetch(`${BASE_URL}partymaster/${id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(party),
            });

            const data = await response.json();

            if (data.status === 1) {
                navigate('/PartyMasterList');
            } else {
                setError(data.message);
            }
        } catch (error) {
            setError('There was an error updating the party data.');
        }
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Edit Customer</h3>
                        </div>
                    </div>
                </div>
            </div>

            {/* Edit Party Form */}
            <section className="section">
                <div className="row" id="basic-table">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <h4>Edit Customer</h4>
                            </div>
                            <div className="card-body">
                                {error && <div className="alert alert-danger">{error}</div>}

                                {isLoading ? (
                                    <div>Loading...</div>
                                ) : (
                                    <form onSubmit={handleSubmit}>
                                        <div className="mb-3">
                                            <label htmlFor="name" className="form-label">Name</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="name"
                                                name="name"
                                                value={party.name}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>

                                        <div className="mb-3">
                                            <label htmlFor="number" className="form-label">Contact Number</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="number"
                                                name="number"
                                                value={party.number}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>

                                        <div className="mb-3">
                                            <label htmlFor="address" className="form-label">Address</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="address"
                                                name="address"
                                                value={party.address}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>

                                        <div className="mb-3">
                                            <label htmlFor="city" className="form-label">City</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="city"
                                                name="city"
                                                value={party.city}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>

                                        <div className="mb-3">
                                            <label htmlFor="pincode" className="form-label">Pincode</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="pincode"
                                                name="pincode"
                                                value={party.pincode}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>

                                        <div className="mb-3">
                                            <label htmlFor="state" className="form-label">State</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="state"
                                                name="state"
                                                value={party.state}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>

                                        <div className="mb-3">
                                            <label htmlFor="type_karigar" className="form-label">Type of Karigar</label>
                                            <select
                                                className="form-control"
                                                id="type_karigar"
                                                name="type_karigar"
                                                value={party.type_karigar}
                                                onChange={handleChange}
                                                required
                                            >
                                                <option value="Supplier">Supplier</option>
                                                <option value="Manufacturer">Manufacturer</option>
                                                <option value="Dealer">Dealer</option>
                                            </select>
                                        </div>

                                        <div className="mb-3">
                                            <label htmlFor="dob" className="form-label">Date of Birth</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                id="dob"
                                                name="dob"
                                                value={party.dob}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>

                                        <div className="mb-3">
                                            <label htmlFor="aod" className="form-label">Anniversary Date</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                id="aod"
                                                name="aod"
                                                value={party.aod}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>

                                        <div className="mb-3">
                                            <label htmlFor="mail_id" className="form-label">Email</label>
                                            <input
                                                type="email"
                                                className="form-control"
                                                id="mail_id"
                                                name="mail_id"
                                                value={party.mail_id}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>

                                        <div className="mb-3">
                                            <label htmlFor="password" className="form-label">Password</label>
                                            <input
                                                type="password"
                                                className="form-control"
                                                id="password"
                                                name="password"
                                                value={party.password}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>

                                        <button type="submit" className="btn btn-primary">Update Customer</button>
                                    </form>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* End Edit Party Form */}
        </div>
    );
};

export default EditPartyMaster;
